export default __webpack_public_path__ + "assets/images/close-icon-06273c07.svg";